import Service from '../Service';
import { addFingerprintToRequest } from './utils';
import {
  CreateUserForm,
  CreateUserRequest,
  RequestParamsUsers,
  ResponseErrorBody
} from '../../types';
import Request from '../Request';

export default async function(params: RequestParamsUsers) {
  const request = await addFingerprintToRequest(
    new Request<RequestParamsUsers>('/api/auth/users')
      .setMethod('POST')
      .setPayload(params)
  );
  const service = new Service<any, ResponseErrorBody>(request);
  return await service.send();
}

export async function createUserMarketing(params: CreateUserForm) {
  const json = {
    email: params.email,
    firstName: params.firstName,
    lastName: params.secondName,
    password: params.password
  };
  const request = await addFingerprintToRequest(
    new Request<CreateUserRequest>('/api/marketing/signup')
      .setMethod('POST')
      .setPayload(json)
  );
  const service = new Service<any, ResponseErrorBody>(request);
  return await service.send();
}

export async function emailConfirmation(uid: string, token: string) {
  const request = await addFingerprintToRequest(
    new Request(
      `/api/auth/users/${uid}/email/confirmation?token=${token}`
    ).setMethod('POST')
  );
  const service = new Service<any, ResponseErrorBody>(request);
  return await service.send();
}
